module.exports = __webpack_public_path__ + "media/a5.96961fc1.wav";